import { isProductionEnvironment } from '../../../utils/env';

export const getInitialState = isRenderedOnServer => {
  if (isProductionEnvironment()) {
    if (isRenderedOnServer) {
      return {
        short_name: '{{ accountData.short_name }}',
        full_name: '{{ accountData.full_name }}',
        avatar_url: '{{ accountData.avatar_url }}',
        background_image_url: '{{ background_image_url }}',
        address: {
          lines: [
            {
              line: '{{ accountData.address.lines[0].line }}',
            },
          ],
          postal_code: '{{ accountData.address.postal_code }}',
          city: '{{ accountData.address.city }}',
        },
        bank_accounts: {
          accounts: [
            {
              account_number: '{{ accountData.bank_accounts.accounts[0].account_number }}',
            },
          ],
        },
        csrf: '{% if csrf is defined %}{{ csrf }}{% endif %}',
        getRegulations: "{{ documents.getDocumentByType('regulations').getFileUrl }}",
        getCookies: "{{ documents.getDocumentByType('cookies_policy').getFileUrl }}",
        getPrivacyPolicy: "{{ documents.getDocumentByType('privacy_policy').getFileUrl }}",
        isDonateConfirmation: "{{ message == 'donate_confirmation' }}",
        donationSuccessPageAdditionalText: "{{ success_page_additional_text ?? '' }}",
        accountId: '{{ accountId }}',
        donationAmount: {
          predefinedValues:
            '{% if donationAmount is defined %}{{ donationAmount.predefined_values|json_encode() }}{% else %}{{ null }}{% endif %}',
          allowOwnAmount:
            '{% if donationAmount is defined %}{{ donationAmount.allow_own_amount }}{% else %}{{ null }}{% endif %}',
          minimalValue:
            '{% if donationAmount is defined %}{{ donationAmount.minimal_value }}{% else %}{{ null }}{% endif %}',
        },
        massOfferingAmount: {
          predefinedValues:
            '{% if massOfferingAmount is defined %}{{ massOfferingAmount.predefined_values|json_encode() }}{% else %}{{ null }}{% endif %}',
          allowOwnAmount:
            '{% if massOfferingAmount is defined %}{{ massOfferingAmount.allow_own_amount }}{% else %}{{ null }}{% endif %}',
          minimalValue:
            '{% if massOfferingAmount is defined %}{{ massOfferingAmount.minimal_value }}{% else %}{{ null }}{% endif %}',
        },
      };
    }

    return null;
  }

  return {
    short_name: 'Parafia Demo',
    full_name: 'Parafia Wersja Demonstracyjna',
    avatar_url:
      'https://deum-static.s3-eu-central-1.amazonaws.com/accounts/654463132773478400/uploads/logo.jpg',
    background_image_url:
      'https://images.unsplash.com/photo-1475137979732-b349acb6b7e3?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
    address: {
      lines: [
        {
          line: 'ul. Domaniewska 20',
        },
      ],
      postal_code: '02-672',
      city: 'Warszawa',
    },
    bank_accounts: {
      accounts: [
        {
          account_number: '77 1240 6247 1111 0000 4975 7086',
        },
      ],
    },
    csrf: 'someRandomToken',
    getRegulations: "{{ documents.getDocumentByType('regulations').getFileUrl }}",
    getCookies: "{{ documents.getDocumentByType('cookies_policy').getFileUrl }}",
    getPrivacyPolicy: "{{ documents.getDocumentByType('privacy_policy').getFileUrl }}",
    isDonateConfirmation: false,
    donationSuccessPageAdditionalText: 'Msza św. w intencji darczyńców o 17',
    accountId: '1516868980247126016',
    donationAmount: {
      predefinedValues: [40, 70, 200],
      allowOwnAmount: true,
      minimalValue: 1,
    },
    massOfferingAmount: {
      predefinedValues: [30, 60, 100, 0],
      allowOwnAmount: true,
      minimalValue: 1,
    },
  };
};
